import React from 'react';
import Box from '@mui/material/Box';

/**
 * FormGrid — Enterprise Design System
 *
 * CSS Grid layout container for form fields with responsive column reduction.
 * Desktop shows full columns, then reduces as viewport narrows:
 *   lg: requested columns | md: min(cols, 3) | sm: min(cols, 2) | xs: 1
 *
 * Props:
 *  - columns: 1 | 2 | 3 | 4 (default: 1) — maximum columns at largest breakpoint
 *  - children: ReactNode — form fields to lay out in the grid
 *  - sx: object — additional MUI sx overrides
 */

const getColumns = (cols) => ({
  xs: 1,
  sm: Math.min(cols, 2),
  md: Math.min(cols, 3),
  lg: cols,
});

function FormGrid({ columns = 1, children, sx }) {
  const responsiveCols = getColumns(columns);

  return (
    <Box
      sx={{
        display: 'grid',
        gap: '16px',
        gridTemplateColumns: {
          xs: `repeat(${responsiveCols.xs}, 1fr)`,
          sm: `repeat(${responsiveCols.sm}, 1fr)`,
          md: `repeat(${responsiveCols.md}, 1fr)`,
          lg: `repeat(${responsiveCols.lg}, 1fr)`,
        },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

export { getColumns };
export default FormGrid;
